import { usePutMutation } from "@/api/swr/useMutation";
import {
  answerSubCategoryRequestSchema,
  answerSubCategoryResponseSchema,
} from "@/schema/app/assessment/answerSubCategoryDetail";

type Config = Parameters<typeof usePutMutation>[3];

export const useSaveChanges = (subCategoryId: string, config?: Config) => {
  return usePutMutation(
    answerSubCategoryRequestSchema,
    answerSubCategoryResponseSchema,
    `/app/assessment/answer_sub_categories/${subCategoryId}/save_changes`,
    config,
  );
};
